/**
 * @class Validator
 * @description Class in charge of validating Health Card Numbers depending on region. Scalable to different regions.
 * Must use same country and region codes as in database.
 */
class RegionCodeValidator {

    private readonly countryRegionData: object = {
        CA: {
            placeHolder: "___ ___",
            regExp: /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/,
            textMask: "A1A 1A1",
        },
        MX: {
            placeHolder: "_____",
            regExp: /^\d{5}$/,
            textMask: "11111",
        },
        CO: {
            placeHolder: "_____",
            regExp: /^\d{6}$/,
            textMask: "111111",
        },
        US: {
            placeHolder: "_____",
            regExp: /^\d{5}$/,
            textMask: "11111",
        },
        NONE: {
            placeHolder: "",
            regExp: null,
            textMask: "",
        }
    }
    public getRegionTextMaskByCountry(country: string): string {
        if (this.countryRegionData[country]) {
            return this.countryRegionData[country].textMask;
        }
        return "";
    }
    public getRegionCodeNumberOfCharacters(country: string): number {
        if (this.countryRegionData[country]) {
            return this.countryRegionData[country].textMask.replace(/\s|\(|\)|_|-|\+/g, '').length;
        }
        return 0;
    }
    public validateRegionCodeByCountry(country: string, regionCode: string): boolean {
        if (this.countryRegionData[country]) {
            return this.countryRegionData[country].regExp.test(regionCode.replace(/\s|\(|\)|_|-|\+/g, ''));
        }
        return true;
    }
    public getRegionCodePlaceHolderByCountry(country: string): string {
        if (this.countryRegionData[country]) {
            return this.countryRegionData[country].placeHolder;
        }
        return "";
    }
}
export default new RegionCodeValidator();


// WEBPACK FOOTER //
// ./src/services/Validator/RegionCode/RegionCodeValidator.ts